// extracted by mini-css-extract-plugin
export var item = "games-list-module--item--b81e6";
export var list = "games-list-module--list--3a848";